import React, { FC } from 'react';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import styled from 'styled-components/native';

import { useCountdown, useLoginAttemptText } from '@webtrader/core/hooks/demoCreation/useCountdown';
import { useAuth } from '@webtrader/core/services/auth';
import { useTheme } from '@webtrader/core/services/theme/v2';
import { rgba } from '@webtrader/core/themes';

import Text from '@/components/Text';

const LoginAttempt: FC = () => {
  const { theme } = useTheme();

  const { lockedUntil = 0 } = useAuth();

  const timer = useCountdown(lockedUntil);
  const loginAttemptLiner = useLoginAttemptText(timer);

  if (timer[0] <= 0 && timer[1] <= 0) {
    return null;
  }

  return (
    <LoginAttemptContainer>
      <LoginAttemptIcon>
        <MaterialIcons name="error-outline" size={16} color={theme.colors.error[0]} />
      </LoginAttemptIcon>
      <LoginAttemptText>{loginAttemptLiner}</LoginAttemptText>
    </LoginAttemptContainer>
  );
};

export default LoginAttempt;

const LoginAttemptContainer = styled.View`
  flex-direction: row;
  display: flex;

  margin-top: 10px;
  padding: 8px;

  align-items: center;

  background-color: ${({ theme }) => rgba(theme.colors.error[0], 0.1)};
`;

const LoginAttemptIcon = styled.View`
  display: flex;
  margin-end: 10px;
`;

const LoginAttemptText = styled(Text)`
  display: flex;
  color: ${({ theme }) => theme.colors.error[0]};
`;
